@if (isApproximateYearInput) {
  <div class="flex items-center p-2 gap-2">
    <span>ca.</span>
    <p-toggleswitch
      name="approx"
      [(ngModel)]="isApproximate"
      [ngModelOptions]="{ standalone: true }"
      (onChange)="approxChanged.emit(isApproximate)"
    />
    <span>Jahr</span>
    <p-toggleswitch
      name="yearOnly"
      [(ngModel)]="isYearOnly"
      [ngModelOptions]="{ standalone: true }"
      (onChange)="yearOnlyChanged.emit(isYearOnly)"
    />
  </div>
}

<div class="w-full overflow-hidden">
  <p-inputgroup>
    <p-inputgroup-addon class="relative p-0 cursor-pointer">
      <i
        class="pi pi-calendar absolute left-3 top-1/2 -translate-y-1/2 z-10 cursor-pointer text-(--p-primary-color)"
        [class.text-gray-300]="disabled"
        [class.cursor-default]="disabled"
        (click)="!disabled && triggerNativePicker()"
      ></i>
      <input
        #nativeDateInput
        type="date"
        name="native-date-{{ id }}"
        autocomplete="off"
        class="absolute inset-0 w-full h-full opacity-0 z-20 cursor-pointer scale-[200%] translate-x-[-20px]"
        [class.cursor-default]="disabled"
        [class.pointer-events-none]="disabled"
        [disabled]="disabled"
        (change)="onNativeDateSelect($event)"
      />
    </p-inputgroup-addon>
    <p-iftalabel>
      <label for="{{ id }}">
        {{ label | transloco }}
        @if (required) {
          <span class="required text-red-400">*</span>
        }
      </label>
      <input
        type="text"
        pInputText
        [id]="id"
        name="date-text-{{ id }}"
        autocomplete="off"
        autocorrect="off"
        [value]="getDisplayValue()"
        (input)="onRawInput($event)"
        [placeholder]="placeholder ? (placeholder | transloco) : 'tt.mm.jjjj'"
        [disabled]="disabled"
        [ngClass]="{
          '!border-red-500': !inputValid,
        }"
      />
    </p-iftalabel>
  </p-inputgroup>

  <ng-content select="[append]"></ng-content>
</div>
